import cx from 'classnames'

import { PersonPropertyValue, instanceOfPersonValue } from 'api/clients/PropertyClient'
import Styles from '../PropertyValue.module.scss'
import Avatar from 'common/Avatar/Avatar'
import { getInitials } from 'utils'
import { CloseButton } from 'components/Buttons/CloseButton'

interface Props {
  propertyValue: PersonPropertyValue
  onRemove?: (propertyValue: PersonPropertyValue) => void
  hideName?: boolean
  avatarSize?: number
  avatarClassName?: string
  avatarContainerClassName?: string
  userClassName?: string
}

const Person = ({
  propertyValue,
  onRemove,
  hideName,
  avatarSize,
  avatarClassName,
  avatarContainerClassName,
  userClassName,
}: Props) => {
  if (!instanceOfPersonValue(propertyValue)) return <></>

  const { value: ownerData } = propertyValue

  return (
    <div className={cx(Styles.avatarContainer, avatarContainerClassName)}>
      <Avatar
        url={ownerData.creator_image_url}
        className={cx(Styles.avatar, avatarClassName, { [Styles.withoutName]: hideName })}
        label={getInitials(ownerData.creator_name)}
        size={avatarSize ?? 20}
      />
      {!hideName && (
        <span className={cx(Styles.userDisplayName, userClassName)} data-testid="person-property-value-creator-name">
          {ownerData.creator_name}
        </span>
      )}
      {onRemove && (
        <CloseButton className={Styles.closeButton} size="sm" onClick={() => onRemove(propertyValue)}></CloseButton>
      )}
    </div>
  )
}

export default Person
